export type AppointmentPaymentOrigin = 'pacote' | 'avulsa' | 'sem_repasse';

export function normalizeAppointmentPaymentOrigin(
  value?: string | null
): AppointmentPaymentOrigin | null {
  if (value === 'pacote' || value === 'avulsa' || value === 'sem_repasse') {
    return value;
  }

  return null;
}

export function resolveAppointmentPaymentOriginForBilling(
  origin: 'pacote' | 'avulsa'
): AppointmentPaymentOrigin {
  return origin;
}

export function resolveAppointmentPaymentOriginForNoShow(
  willBeCharged: boolean
): AppointmentPaymentOrigin {
  return willBeCharged ? 'avulsa' : 'sem_repasse';
}

export function resolveAppointmentPaymentOriginPatch(params: {
  currentOrigin?: string | null;
  status: 'completed' | 'no_evaluated' | 'no_show';
  hasNewFinancialImpact: boolean;
  billingOrigin?: 'pacote' | 'avulsa';
}): AppointmentPaymentOrigin | null {
  const currentOrigin = normalizeAppointmentPaymentOrigin(params.currentOrigin);

  if (params.status === 'no_show') {
    return resolveAppointmentPaymentOriginForNoShow(params.hasNewFinancialImpact);
  }

  if (currentOrigin) {
    return currentOrigin;
  }

  if (!params.hasNewFinancialImpact) {
    return null;
  }

  if (params.billingOrigin) {
    return resolveAppointmentPaymentOriginForBilling(params.billingOrigin);
  }

  return null;
}
